import { render, staticRenderFns } from "./userTags.vue?vue&type=template&id=1d6a2822&scoped=true&"
import script from "./userTags.vue?vue&type=script&lang=js&"
export * from "./userTags.vue?vue&type=script&lang=js&"
import style0 from "./userTags.vue?vue&type=style&index=0&id=1d6a2822&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6a2822",
  null
  
)

export default component.exports